import { Image } from '@chakra-ui/react';
import getStaticAsset from '../../helper/utils/utilsStaticAsset';
import './styles.css';

const Header = () => (
    <header>
        <Image src={getStaticAsset('dream_us_logo.webp')} alt='dream_us_logo' w={{ base: '50%', md: '35%' }} my={3} />
    </header>
);

export default Header;
